const getApiBaseUrl = (): string => {
  if (window.__PWA_CONFIG__?.api_base_url) {
    return window.__PWA_CONFIG__.api_base_url;
  }
  return window.location.hostname === 'localhost'
    ? 'https://localhost/coreland/api'
    : 'https://sales.paydia.com/taste-of-charlotte/api';
};

export const API_BASE_URL = getApiBaseUrl();

export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/account/login.php',
  LOGOUT: '/account/logout.php',
  REGISTER: '/account/create-passwordless.php',
  PASSWORD_RESET: '/account/password-reset.php',

  // Account
  CARDS: '/account/cards.php',
  GET_VALUE: '/account/get-value.php',
  GET_HISTORY: '/account/get-history.php',
  DEMOGRAPHICS: '/account/demographics.php',

  // Event
  EVENT_LIST: '/event/list.php',
  GET_ACCOUNT: '/event/get-account.php',

  // Cart
  CART_START: '/cart/start.php',
  CART_SET_CONTENTS: '/cart/set-contents.php',

  // Payment
  CARD_ON_FILE: '/payment/card-on-file.php',
  PASSWORD_SET: '/payment/password-set.php',

  // Account Management
  REMOVE_CARD: '/account/cof/remove.php',
  PASSWORD_RESET_PAYMENT: '/account/payment-password-reset.php',
  ACCOUNT_DELETE: '/account/delete.php',

  // Items
  GET_ITEMS: '/item/get.php',

  // Sharing
  GIVE_TO_GUEST: '/event/give-to-guest.php',

  // Tipping
  GET_VENDOR: '/event/get-vendor.php',
  TIP_VENDOR: '/event/tip-vendor.php',

  // Voting
  VOTE_STATUS: '/event/vote-status.php',
  VOTE: '/event/vote.php',

  // Notifications
  NOTIFICATION_LIST: '/notification/list.php',
  NOTIFICATION_READ: '/notification/read.php',

  // Push
  PUSH_VAPID_KEY: '/push/vapid-public-key.php',
  PUSH_SUBSCRIBE: '/push/subscribe.php',
  PUSH_UNSUBSCRIBE: '/push/unsubscribe.php',
} as const;

export default API_ENDPOINTS;
